<template>
  <a7-dashboard class="a7-dashboard-geral">
    <a7-dashlet-visao-evolucao
      v-for="card in cards"
      :key="card.descricao"
      :titulo="card.descricao"
      :medidas="card.medidas"
      :tipo="card.tipo"/>
  </a7-dashboard>
</template>

<script>
import A7Dashboard from './A7Dashboard';
import A7DashletVisaoEvolucao from './A7DashletVisaoEvolucao';

export default {
  name: 'a7-dashboard-geral',
  components: {
    A7Dashboard,
    A7DashletVisaoEvolucao
  },
  data() {
    return {
      cards: [
        {
          descricao: 'Venda',
          medidas: [
            {
              visao: 56295449142,
              medida: 'Venda',
              tipoMedida: 'A'
            },
            {
              visao: 56295449142,
              medida: '% Desconto',
              tipoMedida: 'B',
              datasetLabel: 'Desconto'
            },
            {
              visao: 56295449142,
              medida: '% Custo',
              tipoMedida: 'B',
              datasetLabel: 'Custo'
            },
            {
              visao: 56295449142,
              medida: '% Lucro',
              tipoMedida: 'B',
              datasetLabel: 'Lucro'
            }
          ],
          tipo: 'linha'
        },
        {
          descricao: 'Compra',
          medidas: [
            {
              visao: 56316847137,
              medida: 'Compra',
              tipoMedida: 'A'
            },
            {
              visao: 56316847137,
              medida: '% Desconto',
              tipoMedida: 'B',
              datasetLabel: 'Desconto'
            },
            {
              visao: 56316847137,
              medida: '% Margem de Venda',
              tipoMedida: 'B',
              datasetLabel: 'Margem de Venda'
            }
          ],
          tipo: 'linha'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
